import { getApiOrigin } from "./apiBaseUrl";

const ABSOLUTE_URL_PATTERN = /^(?:[a-z]+:)?\/\//i;

export const resolveAssetUrl = (value) => {
  if (!value) return null;
  if (typeof value !== "string") return value;
  if (value.startsWith("data:") || value.startsWith("blob:")) return value;
  if (ABSOLUTE_URL_PATTERN.test(value)) return value;

  const apiBase = getApiOrigin().trim().replace(/\/$/, "");
  if (value.startsWith("/")) {
    return apiBase ? `${apiBase}${value}` : value;
  }

  return apiBase ? `${apiBase}/${value.replace(/^\/+/, "")}` : value;
};

export const withAssetVersion = (value, version) => {
  const resolved = resolveAssetUrl(value);
  if (!resolved) return null;

  const separator = resolved.includes("?") ? "&" : "?";
  return `${resolved}${separator}v=${version || Date.now()}`;
};
